import { render } from "./moudle6.vue?vue&type=template&id=680c26e8&ts=true"
import script from "./moudle6.vue?vue&type=script&lang=ts"
export * from "./moudle6.vue?vue&type=script&lang=ts"

import "./moudle6.vue?vue&type=style&index=0&id=680c26e8&lang=scss&scope=true"

import exportComponent from "/Users/haoxunming/Desktop/flowbox公司项目/flowbox/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__